import React from "react";
import "../../resources/user.css"
import Username from "../postsSections/Username";

function User({ user, style }) {
  const backendApiPath = process.env.REACT_APP_BACKEND_API_PATH;
  return (
    <div
      className="user"
      style={{...style}}
    >
      <div className="post-profile-pic">
        <div className="pic-container" style={{
            margin: 0
        }}>
          <img src={`${backendApiPath}/profile/${user.username}/pic`} />
        </div>
      </div>
      <Username username={user.username} style={{
        marginLeft: 20
      }} />
    </div>
  );
}

export default User;
